import firebase from 'firebase'
// import Firebase from 'firebase/app'
import credentials from './credentials'

export const firebaseApp = firebase.initializeApp(credentials.firebase)